import { hasTreatment, includesTreatment } from '@/lib/features/utils';
import { features } from '@/lib/features/features';

// Experiments related to specific features

export const shouldShowOTP = (): boolean => {
  return hasTreatment('FEATURE_ONBOARDING_OTP');
};

export const suppressSignup = (): boolean => {
  if (features.isActive('isForcedSignUp')) {
    return false;
  }

  const memberMatchSilent = includesTreatment({
    feature: 'FEATURE_EXPAND_MEMBER_MATCHING',
    treatment: 'Trmt_FEATURE_EXPAND_MEMBER_MATCHING_2',
  });
  const wpsMemberMatchSilent = includesTreatment({
    feature: 'FEATURE_EXPAND_MEMBER_MATCHING_WPS',
    treatment: 'Trmt_FEATURE_EXPAND_MEMBER_MATCHING_WPS_NO_OPT_IN',
  });
  const memberMatchInterstitialWithNoToggle = includesTreatment({
    feature: 'FEATURE_EXPAND_MEMBER_MATCHING',
    treatment:
      'Trmt_FEATURE_EXPAND_MEMBER_MATCHING_NO_TOGGLE__WITH_INTERSTITIAL',
  });
  const wpsMemberMatchInterstitialWithNoToggle = includesTreatment({
    feature: 'FEATURE_EXPAND_MEMBER_MATCHING_WPS',
    treatment:
      'Trmt_FEATURE_EXPAND_MEMBER_MATCHING_WPS_NO_TOGGLE__WITH_INTERSTITIAL',
  });
  const toggleSuppressRoW = hasTreatment(
    'FEATURE_EXISTING_EMAIL_SUPPRESS_SIGNUP',
  );

  return (
    memberMatchSilent ||
    wpsMemberMatchSilent ||
    memberMatchInterstitialWithNoToggle ||
    wpsMemberMatchInterstitialWithNoToggle ||
    toggleSuppressRoW
  );
};
